"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeGlobals = initializeGlobals;
exports.initializeGlobalsFromScript = initializeGlobalsFromScript;

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _bootstrap = require("@insided/shared/bootstrap");

/* eslint-disable @typescript-eslint/naming-convention */
function extractGlobalsFromScript(scriptElement) {
  var _scriptElement$getAtt3, _scriptElement$getAtt4, _window$appState, _scriptElement$getAtt5, _scriptElement$getAtt6, _scriptElement$getAtt7, _scriptElement$getAtt8, _document$getElementB, _document$getElementB2, _scriptElement$getAtt9, _scriptElement$getAtt10, _scriptElement$getAtt11, _document$getElements, _scriptElement$getAtt12, _scriptElement$getAtt13, _scriptElement$getAtt14, _scriptElement$getAtt15, _scriptElement$getAtt16, _scriptElement$getAtt17;

  var defaultSearchToken = {
    client_id: '',
    token: '',
    basicToken: '',
    isZendeskFederatedSearchEnabled: false,
    hiddenCategories: [],
    availableIndexes: []
  };
  var activeModules = [];

  try {
    var _scriptElement$getAtt, _JSON$parse;

    var modulesStr = (_scriptElement$getAtt = scriptElement.getAttribute('data-modules')) !== null && _scriptElement$getAtt !== void 0 ? _scriptElement$getAtt : '';
    activeModules = (_JSON$parse = JSON.parse(modulesStr)) !== null && _JSON$parse !== void 0 ? _JSON$parse : [];
  } catch (e) {
    activeModules = [];
  }

  var guestSearchToken;

  try {
    var _scriptElement$getAtt2, _JSON$parse2;

    var searchToken = (_scriptElement$getAtt2 = scriptElement.getAttribute('data-search')) !== null && _scriptElement$getAtt2 !== void 0 ? _scriptElement$getAtt2 : '';
    guestSearchToken = (_JSON$parse2 = JSON.parse(searchToken)) !== null && _JSON$parse2 !== void 0 ? _JSON$parse2 : defaultSearchToken;
  } catch (e) {
    guestSearchToken = defaultSearchToken;
  }

  var basePath = (_scriptElement$getAtt3 = scriptElement.getAttribute('data-basepath')) !== null && _scriptElement$getAtt3 !== void 0 ? _scriptElement$getAtt3 : '';
  var normalizedBasePath = basePath ? basePath.replace(/\/js\/$/, '/') : '';
  var defaultCookieLevel = parseInt((_scriptElement$getAtt4 = scriptElement.getAttribute('data-defaultCookieLevel')) !== null && _scriptElement$getAtt4 !== void 0 ? _scriptElement$getAtt4 : '3');
  return {
    appState: (_window$appState = window.appState) !== null && _window$appState !== void 0 ? _window$appState : {
      appName: null,
      activeHubModules: [],
      activeEntities: {}
    },
    region: (_scriptElement$getAtt5 = scriptElement.getAttribute('data-region')) !== null && _scriptElement$getAtt5 !== void 0 ? _scriptElement$getAtt5 : '',
    environment: (_scriptElement$getAtt6 = scriptElement.getAttribute('data-environment')) !== null && _scriptElement$getAtt6 !== void 0 ? _scriptElement$getAtt6 : '',
    communityId: (_scriptElement$getAtt7 = scriptElement.getAttribute('data-communityId')) !== null && _scriptElement$getAtt7 !== void 0 ? _scriptElement$getAtt7 : '',
    cssLink: (_scriptElement$getAtt8 = scriptElement.getAttribute('data-cssLink')) !== null && _scriptElement$getAtt8 !== void 0 ? _scriptElement$getAtt8 : '',
    cssVariables: (_document$getElementB = (_document$getElementB2 = document.getElementById('css-variables')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.innerHTML) !== null && _document$getElementB !== void 0 ? _document$getElementB : '',
    communityUrl: (_scriptElement$getAtt9 = scriptElement.getAttribute('data-communityUrl')) !== null && _scriptElement$getAtt9 !== void 0 ? _scriptElement$getAtt9 : '',
    controlUrl: (_scriptElement$getAtt10 = scriptElement.getAttribute('data-controlUrl')) !== null && _scriptElement$getAtt10 !== void 0 ? _scriptElement$getAtt10 : '',
    application: (_scriptElement$getAtt11 = scriptElement.getAttribute('data-application')) !== null && _scriptElement$getAtt11 !== void 0 ? _scriptElement$getAtt11 : '',
    communityLanguage: (_document$getElements = document.getElementsByTagName('html')[0].getAttribute('lang')) !== null && _document$getElements !== void 0 ? _document$getElements : '',
    defaultCdn: (_scriptElement$getAtt12 = scriptElement.getAttribute('data-defaultCdn')) !== null && _scriptElement$getAtt12 !== void 0 ? _scriptElement$getAtt12 : '',
    facebookAppId: (_scriptElement$getAtt13 = scriptElement.getAttribute('data-fb-app-id')) !== null && _scriptElement$getAtt13 !== void 0 ? _scriptElement$getAtt13 : '',
    eventLogger: (_scriptElement$getAtt14 = scriptElement.getAttribute('data-eventLogger')) !== null && _scriptElement$getAtt14 !== void 0 ? _scriptElement$getAtt14 : '',
    cookieConfig: (_scriptElement$getAtt15 = scriptElement.getAttribute('data-cookieConfig')) !== null && _scriptElement$getAtt15 !== void 0 ? _scriptElement$getAtt15 : '',
    defaultCookieLevel: defaultCookieLevel,
    selectedCookieLevel: parseInt((_scriptElement$getAtt16 = scriptElement.getAttribute('data-selectedCookieLevel')) !== null && _scriptElement$getAtt16 !== void 0 ? _scriptElement$getAtt16 : defaultCookieLevel.toString()),
    basePath: normalizedBasePath,
    subfolderPrefix: (_scriptElement$getAtt17 = scriptElement.getAttribute('data-subfolderPrefix')) !== null && _scriptElement$getAtt17 !== void 0 ? _scriptElement$getAtt17 : '',
    activeModules: activeModules,
    guestSearchToken: guestSearchToken
  };
}

function initializeGlobalsFromScript(state) {
  (0, _globals.default)('appState', state.appState);
  (0, _globals.default)('region', state.region);
  (0, _globals.default)('environment', state.environment);
  (0, _globals.default)('communityId', state.communityId);
  (0, _globals.default)('cssLink', state.cssLink);
  (0, _globals.default)('cssVariables', state.cssVariables);
  (0, _globals.default)('communityUrl', state.communityUrl);
  (0, _globals.default)('controlUrl', state.controlUrl);
  (0, _globals.default)('application', state.application);
  (0, _globals.default)('communityLanguage', state.communityLanguage);
  (0, _globals.default)('defaultCdn', state.defaultCdn);
  (0, _globals.default)('facebookAppId', state.facebookAppId);
  (0, _globals.default)('eventLogger', state.eventLogger);
  (0, _globals.default)('cookieConfig', state.cookieConfig);
  (0, _globals.default)('defaultCookieLevel', state.defaultCookieLevel);
  (0, _globals.default)('selectedCookieLevel', state.selectedCookieLevel);
  (0, _globals.default)('basePath', state.basePath);
  (0, _globals.default)('subfolderPrefix', state.subfolderPrefix);
  (0, _globals.default)('activeModules', state.activeModules);
  (0, _globals.default)('guestSearchToken', state.guestSearchToken);

  if (state.basePath) {
    __webpack_public_path__ = state.basePath;
  }
}

function initializeGlobals() {
  var scriptElement = (0, _bootstrap.resolveScriptElement)();
  var state = extractGlobalsFromScript(scriptElement);
  initializeGlobalsFromScript(state);
}